import { Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { ApiService } from '@app/core/services/api.service';
import { CrudService } from '@app/core/services/crud.service';
import { CourseStudio } from './../../../core/models/courses.model';
@Injectable({
  providedIn: 'root',
})
export class StudioService extends CrudService<CourseStudio> {
  constructor(api: ApiService) {
    super(api, `${portalConst.api.trilhas}/`);
  }

  public showCourseBySlug(slug: any) {
    return this.api.get<CourseStudio>(`${this.url}v1/curso/${slug}`);
  }

  public postCourse(data: any) {
    return this.api.post<CourseStudio>(`${this.url}v1/curso`, data);
  }

  public updateCourse(courseId: number, data: any) {
    return this.api.put<CourseStudio>(`${this.url}v1/curso/${courseId}`, data);
  }

  public destroyCourse(courseId: number) {
    return this.api.delete<CourseStudio>(`${this.url}v1/curso/${courseId}`);
  }

  public duplicateCourse(curso_id: number, colecao_id: number) {
    return this.api.get(`${this.url}v1/cursos/duplicar`, { colecao_id, curso_id });
  }
}
